import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FilterBasic from '../../../basicElement/FilterBasic';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import dictCache from '../../../../common/dictCache';

class CoFilter extends Component {
    static contextTypes = {
        configure: PropTypes.object,
    };

    state = {
        areaOptions: [],
        diseaseOptions: [],
        businessList: [],
    }

    componentDidMount() {
        this.loadAreaList();
        this.queryWithLevelByParams();
        // 点击返回，级联选择的’疾病‘选择项丢失 bug 31562
        const { params } = this.props;
        if (params.investigationAreaId) {
            this.loadDiseaseList(params.investigationAreaId);
        }
    }
    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const areaOptions = (res.data || []).map(item => {
                const { investigationAreaId, investigationAreaName } = item;
                return {
                    label: investigationAreaName,
                    value: investigationAreaId,
                };
            });
            this.setState({ areaOptions });
        });
    }

    loadDiseaseList = investigationAreaId => {
        if (!investigationAreaId) return;
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllDisease,
            data: { investigationAreaId },
            dataType: 'json',
            doneResult: res => {
                const diseaseOptions = (res.data || []).map(item => {
                    const { diseaseId, diseaseName } = item;
                    return {
                        value: diseaseId,
                        label: diseaseName,
                    };
                });
                this.setState({ diseaseOptions });
            },
        };
        $.sendRequest(options);
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleChange = (params, key) => {
        if (key === 'investigationAreaId') {
            params.diseaseId = undefined;
            this.props.onChange(params, key);
            this.loadDiseaseList(params.investigationAreaId);
        } else if (key === 'lineOfBusiness') {
            params.secondLineName = undefined;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    getOptions = list => (list || []).map(i => ({ label: i.optionValue, value: i.majorConfigureId }))

    render() {
        const { config, onChange, ...rest } = this.props;
        const { areaOptions, diseaseOptions, businessList } = this.state;
        const { params } = rest;
        const { configure } = this.context;
        const { invState } = sessionStorage;
        const { lineOfBusiness } = params;
        const isCenter = invState == 1;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const secondLineOption = [...secondLineSet].map(i => ({ value: i, label: i }));
        const {
            CO_POSSIBILITY = [], // 可能行
            CO_REASON = [], // 原因
        } = configure || {};
        (CO_POSSIBILITY || []).forEach(i => { i.label = i.typeValue; i.value = i.coTraceConfigureId; });
        (CO_REASON || []).forEach(i => { i.label = i.typeValue; i.value = i.coTraceConfigureId; });
        const filters = [{
            name: 'CO跟踪单号',
            key: 'coTraceNum',
            type: 'input',
        }, {
            name: '项目简称',
            key: 'investigation',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'investigationName',
                style: { width: 160 },
                placeholder: '输入名称检索',
                params: { limit: 20 },
                url: API_URL.investigation.queryInvestigationByName,
                config: { id: 'investigationId', name: 'investigationName' },
            },
        }, {
            name: 'CO跟进状态',
            key: 'followUpStatus',
            type: 'select',
            typeProperty: {
                style: { width: 160 },
                list: [
                    { label: 'CO已上传CTMS，CO完成', value: 'CO已上传CTMS，CO完成' },
                    { label: 'CO待走签署流程', value: 'CO待走签署流程' },
                    { label: 'CO已在签署流程', value: 'CO已在签署流程' },
                    { label: 'CO尚未定稿', value: 'CO尚未定稿' },
                    { label: 'CO已定稿', value: 'CO已定稿' },
                    { label: 'CO金额尚未达成一致', value: 'CO金额尚未达成一致' },
                    { label: 'CO金额已达成一致', value: 'CO金额已达成一致' },
                ],
            },
        }, {
            name: 'JDE主项目号',
            key: 'jdeMainCode',
            type: 'input',
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            },
        }, {
            name: '执行业务线二级分类',
            key: 'secondLineName',
            type: 'select',
            typeProperty: {
                style: { width: 140 },
                disabled: !lineOfBusiness,
                list: secondLineOption,
            },
        }, {
            name: 'PM',
            key: 'pmNameCodes',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: { width: 140 },
                placeholder: '输入姓名/工号检索',
                params: { limit: 20 },
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            },
        }, {
            name: '项目领域',
            key: 'investigationAreaId',
            type: 'select',
            typeProperty: {
                list: areaOptions,
            },
        }, {
            name: '疾病',
            key: 'diseaseId',
            type: 'select',
            typeProperty: {
                list: diseaseOptions,
                disabled: !params.investigationAreaId,
            },
        }, {
            name: 'PML（包含大区总监）',
            key: 'pmlNameCodes',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: { width: 140 },
                placeholder: '输入姓名/工号检索',
                params: { limit: 20 },
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            },
        }, {
            name: 'CO可能性',
            key: 'coPossibilityId',
            type: 'select',
            typeProperty: {
                list: CO_POSSIBILITY,
            },
        }, {
            name: 'CO原因',
            key: 'coReasonId',
            type: 'select',
            typeProperty: {
                list: CO_REASON,
            },
        }, {
            name: '状态',
            key: 'approvalStatus',
            type: 'select',
            typeProperty: {
                style: { width: 100 },
                list: [
                    { label: '全部', value: 'ALL' },
                    { label: '待审批', value: 'WAITE' },
                    { label: '审批不通过', value: 'REJECT' },
                    { label: '已审批', value: 'AGREE' },
                ],
            },
        }];
        return (
            <FilterBasic
                filters={filters}
                onChange={this.handleChange}
                {...rest}
            />
        );
    }
}

export default CoFilter;



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/CoFilter.js